import React from "react";
import "./styles.scss";
import Header from "../../app/layouts/Header";
import Footer from "../dashboard/components/footer";
import { SnackBar } from "../../app/components/SnackBar";


const GuestLayout = (props) => {
    return (
        <div className='guest-layout'>
            <Header />
            <SnackBar />
            <div className='guest-layout__body container pt-3 pb-3'>
                {props.children}
            </div>
            <Footer {...props}></Footer>
        </div>
    );
};

export default GuestLayout;
